
const Upload = (props) => {

  return (
    <div>UPLOAD</div>
  );
}

export default Upload;